import { render, staticRenderFns } from "./sport.vue?vue&type=template&id=e6cc1a20"
import script from "./sport.vue?vue&type=script&lang=js"
export * from "./sport.vue?vue&type=script&lang=js"
import style0 from "./sport.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/casino-banners/sport.vue
// module id = hrru
// module chunks = 0